import CryptoJS from "crypto-js";

const CONFIGS = {
	algorithm: "aes256",
	encoding: "utf8",
	secret:
		"5b78544874bb6a2f94a7fe1feb3def8" +
		"cf1efe8d5ea03ca67a5e060b58d0bbb" +
		"79a110a797242e025f38a7221edf9a0" +
		"997bfbf6d1c3b9a73c4fca3849fdeaf" +
		"0cf1fd4b4f3eeb662af2d3c8d6eff36" +
		"07b34d0fda87f856efcf60fae003836" +
		"80913873597d61493efcc94ddeb7dc4" +
		"7811556effc2ed782e6ede6c065a01b" +
		"d8dcb2a79095513be22c2d6cf72c973" +
		"0614ed1ee9af9a77560a0629c8925df" +
		"bb292942aa3005a2983fe9edc203f39" +
		"a8e39df0dcd7a4b2788a2c7b2a1baa9" +
		"4d711443ea64f93f20c16f77fee81ac" +
		"13fcb805e96b47f714fa187cebc6bb8" +
		"765c0b51cd7b28a414bab7a85e29c46" +
		"395ed7f5cb5e77a15e6aea081cfb78b" +
		"79caad9b4be7e4ff",
	type: "hex"
};

export default class EncryptHelper {

	static encryptKey(textToEncrypt) {
		return CryptoJS.SHA256(textToEncrypt, CONFIGS.secret).toString(
			CryptoJS.enc.Base64
		);
	}

	static encrypt(textToEncrypt) {
		return CryptoJS.AES.encrypt(textToEncrypt, CONFIGS.secret).toString();
	}

	static generateHash() {
		return Math.random(0).toString(36).substr(2);
	}

	static decrypt(textToDecrypt) {
		if (textToDecrypt) {
			const bytes = CryptoJS.AES.decrypt(textToDecrypt, CONFIGS.secret);
			return bytes.toString(CryptoJS.enc.Utf8);
		}

		return null;
	}
}
